
import userManager from "@/pages/super-admin/user/userManager";
export default [
    {
        path: 'user-manager', // 用户管理
        name: 'userManager',
        component: userManager
    },
]
